<template>
  <div class="l-container AppointmentsCalendar">
    <!-- <p>mapAppointments</p> -->
    <!-- <div style="height: 50px; overflow: auto">{{mapAppointments}}</div> -->
    <!-- <p>mapNexts</p> -->
    <!-- <div style="height: 50px; overflow: auto">{{mapNexts}}</div> -->
    <!-- <p>concat</p> -->
    <!-- <div style="height: 50px; overflow: auto">{{concat}}</div> -->
    <FullCalendar
      defaultView="dayGridMonth"
      :locale="locale"
      :firstDay="firstDay"
      :header="calendarHeader"
      :plugins="calendarPlugins"
      :events="concat"
      :height="height"
      @datesRender="datesRender"
      @eventClick="handleDateClick"
    />
  </div>
</template>

<script>
import axios from 'axios'
import { getAPIURL } from '@/store/getters.js'
const url = getAPIURL() + '/api/v1/appointments/search?'

const obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  // offset: config.LIMIT,
  // max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'appointment',
  pageNames: 'appointments'
}

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import jaLocale from '@fullcalendar/core/locales/ja' // 日本語化用

export default {
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },

  data () {
    return {
      height: '',
      locale: jaLocale, // 日本語化
      calendarHeader: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
      },
      firstDay: 1, // 月曜日から
      calendarWeekends: true, // 土日を表示するか
      // カレンダーで使用するプラグイン
      calendarPlugins: [
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin
      ],

      search: {
        visit_date: '',
        next_visit_date: ''
      }
    }
  },

  computed: {
    appointments () {
      return this.$store.getters.appointments
    },

    nexts () {
      return this.$store.getters.nexts
    },

    school_stage () {
      return this.$store.getters['appointments/school_stage']
    },

    grade () {
      return this.$store.getters['appointments/grade']
    },

    mapAppointments () {
      return this.appointments.map(appointment => {
        appointment.mapSchool_stage = this.calcSelect(appointment.school_stage, 'school_stage')
        appointment.mapGrade = this.calcSelect(appointment.grade, 'grade')

        appointment.date = appointment.visit_date
        appointment.title = `${appointment.visit_time} ${appointment.address1.slice(0, 4)}... ${appointment.mapSchool_stage}${appointment.mapGrade} ${appointment.f_name}`

        if (appointment.office_id === 2) {
          appointment.backgroundColor = '#fc7976'
          appointment.borderColor = '#fc7976'
        } else {
          appointment.backgroundColor = '#009be5'
          appointment.borderColor = '#009be5'
        }
        return appointment
      })
    },

    mapNexts () {
      return this.nexts.map(next => {
        next.mapSchool_stage = this.calcSelect(next.school_stage, 'school_stage')
        next.mapGrade = this.calcSelect(next.grade, 'grade')

        next.date = next.next_visit_date
        next.title = `${next.next_visit_time} ${next.address1.slice(0, 4)}... ${next.mapSchool_stage}${next.mapGrade} ${next.f_name}`

        if (next.office_id === 2) {
          next.backgroundColor = '#FFA73C'
          next.borderColor = '#FFA73C'
        } else {
          next.backgroundColor = '#41b883'
          next.borderColor = '#41b883'
        }
        return next
      })
    },

    concat () {
      const result = this.mapAppointments.concat(this.mapNexts)
      console.log(result)
      return result
    }
  },

  methods: {
    calcSelect (val, text) {
      if (val) {
        return this[text].filter(item => {
          return item.value === val
        })[0].name
      } else {
        return ''
      }
    },

    handleResize () {
      this.height = window.innerHeight - 113
    },

    handleDateClick (arg) {
      // console.log(arg.event.id)
      this.$router.push({name: 'appointmentindex', params: { id: arg.event.id }})
    },

    datesRender (arg) {
      const year = new Date(arg.view.currentStart).getFullYear()
      const month = ('0' + (new Date(arg.view.currentStart).getMonth() + 1)).slice(-2)
      this.search.visit_date = (year + '-' + month)
      this.search.next_visit_date = (year + '-' + month)

      this.searchTable()
      this.searchTable2()
    },

    // getAppointments () {
    //   this.$store.dispatch('getAppointments')
    // },

    searchTable (e) {
      const search = this.search
      const store = this.$store
      const params = {}
      function searchTable () {
        const paramsList = [
          'visit_date'
        ]
        paramsList.forEach(e => {
          params[e] = [search[e]]
        })
        axios.get(obj.url, {params: params, withCredentials: true})
        .then(res => {
        // success callback
          console.log(res)
          store.state.list.appointments = res.data.appointment
        }, (res) => {
        // error callback
        })
      }

      searchTable()

      // if (obj.TIMER) {
      //   clearTimeout(obj.TIMER)
      //   obj.TIMER = setTimeout(searchTable, obj.wait)
      //   return
      // }
      // obj.TIMER = setTimeout(searchTable, obj.wait)
    },

    searchTable2 (e) {
      const search = this.search
      const store = this.$store
      const params = {}
      function searchTable () {
        const paramsList = [
          'next_visit_date'
        ]
        paramsList.forEach(e => {
          params[e] = [search[e]]
        })
        axios.get(obj.url, {params: params, withCredentials: true})
        .then(res => {
        // success callback
          console.log(res)
          store.state.list.nexts = res.data.appointment
        }, (res) => {
        // error callback
        })
      }

      searchTable()

      // if (obj.TIMER) {
      //   clearTimeout(obj.TIMER)
      //   obj.TIMER = setTimeout(searchTable, obj.wait)
      //   return
      // }
      // obj.TIMER = setTimeout(searchTable, obj.wait)
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getAppointments()

      const year = new Date().getFullYear()
      const month = ('0' + (new Date().getMonth() + 1)).slice(-2)
      vm.search.visit_date = (year + '-' + month)
      vm.search.next_visit_date = (year + '-' + month)

      vm.searchTable()
      vm.searchTable2()
    })
  },

  // beforeRouteLeave (to, from, next) {
  //
  //   next()
  // },

  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss" scoped>
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/timegrid/main.css';

.fc-bg > table > tr > .fc-sun {
  color: red;
  background-color: #fff0f0 !important;
}

.fc-sat {
  color: blue;
  background-color: #f0f0ff;
}
</style>



// WEBPACK FOOTER //
// AppointmentsCalendar.vue?e6ef69b8